// extracted by mini-css-extract-plugin
export default {"card-container":"styles_card-container__vdHe7","cardsList":"styles_cardsList__2jL5D"};